import { handleActions } from 'redux-actions';
import { cloneDeep } from 'lodash';
import moment from 'moment';

import * as actionDefinitions from './actionDefinitions';
import * as userSettingsTypes from '../UserSettings/types';

import { excludeIntacctId, includeIntacctId, sortObjectsByNameAsc } from '../../helpers/utils';
import { TasksStore, TasksStoreItem } from '../../types/redux/stores/tasks.types';
import { SimpleAction } from '../../types/redux/actions';

const initialState: TasksStore = {
  data: [],
  perProjectId: {},
  error: null,
  initialLoad: false,
  loading: false,
  saving: false,
};

const getTasksRequest = (state: TasksStore): TasksStore => {
  return {
    ...state,
    error: null,
    loading: true,
  };
};
const getTasksRequestFailure = (state: TasksStore, action: SimpleAction): TasksStore => {
  return {
    ...state,
    data: [],
    error: action.payload.error,
    loading: false,
  };
};
const getTasksRequestSuccess = (state: TasksStore, action: SimpleAction): TasksStore => {
  const data = action.payload?.data?.res;
  if (action.payload?.data?.showIntacctId) {
    data.map((d: TasksStoreItem) => includeIntacctId(d));
  }
  data.sort(sortObjectsByNameAsc);
  return {
    ...state,
    data,
    error: null,
    initialLoad: true,
    loading: false,
  };
};
const getTasksOfProjectRequest = (state: TasksStore, action: SimpleAction): TasksStore => {
  const projectId = action.payload.projectId;
  if (!projectId) return state;
  return {
    ...state,
    perProjectId: {
      ...state.perProjectId,
      [projectId]: {
        ...state.perProjectId[projectId],
        loading: true,
      },
    },
  };
};
const getTasksOfProjectStopLoading = (state: TasksStore, action: SimpleAction): TasksStore => {
  const projectId = action.payload.projectId;
  if (!projectId) return state;
  return {
    ...state,
    perProjectId: {
      ...state.perProjectId,
      [projectId]: {
        ...state.perProjectId[projectId],
        loading: false,
      },
    },
  };
};
const getTasksOfProjectRequestFailure = (state: TasksStore, action: SimpleAction): TasksStore => {
  const projectId = action.payload?.error?.projectId;
  if (!projectId) return state;
  return {
    ...state,
    perProjectId: {
      ...state.perProjectId,
      [projectId]: {
        ...state.perProjectId[projectId],
        loading: false,
        lastSync: null,
      },
    },
  };
};
const getTasksOfProjectRequestSuccess = (state: TasksStore, action: SimpleAction): TasksStore => {
  const responseData = action.payload.res;
  const projectId = action.payload?.payloadData?.projectId || 'all';
  if (action.payload.showIntacctId) {
    responseData.map((d: TasksStoreItem) => includeIntacctId(d));
  }
  responseData.sort(sortObjectsByNameAsc);
  return {
    ...state,
    perProjectId: {
      ...state.perProjectId,
      [projectId]: {
        loading: false,
        lastSync: moment().toString(),
        data: responseData,
      },
    },
    initialLoad: true,
  };
};

const showIntacctId = (state: TasksStore): TasksStore => {
  const _state = cloneDeep(state);
  _state.data.map((d) => includeIntacctId(d));
  _state.data.sort(sortObjectsByNameAsc);
  for (const key of Object.keys(_state.perProjectId || {})) {
    _state.perProjectId[key]?.data?.map((d) => includeIntacctId(d));
    _state.perProjectId[key]?.data?.sort(sortObjectsByNameAsc);
  }
  return {
    ...state,
    data: _state.data,
    perProjectId: _state.perProjectId,
  };
};
const hideIntacctId = (state: TasksStore): TasksStore => {
  const _state = cloneDeep(state);
  _state.data.map((d) => excludeIntacctId(d));
  _state.data.sort(sortObjectsByNameAsc);
  for (const key of Object.keys(_state.perProjectId || {})) {
    _state.perProjectId[key]?.data?.map((d) => excludeIntacctId(d));
    _state.perProjectId[key]?.data?.sort(sortObjectsByNameAsc);
  }
  return {
    ...state,
    data: _state.data,
    perProjectId: _state.perProjectId,
  };
};

export default handleActions(
  {
    [actionDefinitions.GET_TASKS_REQUEST]: getTasksRequest,
    [actionDefinitions.GET_TASKS_REQUEST_FAILURE]: getTasksRequestFailure,
    [actionDefinitions.GET_TASKS_REQUEST_SUCCESS]: getTasksRequestSuccess,
    [actionDefinitions.GET_TASKS_OF_PROJECT_REQUEST]: getTasksOfProjectRequest,
    [actionDefinitions.GET_TASKS_OF_PROJECT_REQUEST_FAILURE]: getTasksOfProjectRequestFailure,
    [actionDefinitions.GET_TASKS_OF_PROJECT_REQUEST_SUCCESS]: getTasksOfProjectRequestSuccess,
    [actionDefinitions.GET_TASKS_OF_PROJECT_STOP_LOADING]: getTasksOfProjectStopLoading,
    [userSettingsTypes.SHOW_INTACCT_ID]: showIntacctId,
    [userSettingsTypes.HIDE_INTACCT_ID]: hideIntacctId,
  },
  initialState
);
